/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module react/plugins/input-presets/spaces-preset */
import { Types } from '@codistica/types';
import { leadingSpaceBlocker } from '../../input-blockers/internals/leading-space-blocker.js';
import { nonSingleSpaceBlocker } from '../../input-blockers/internals/non-single-space-blocker.js';
import { leadingSpaceFilter } from '../../input-filters/internals/leading-space-filter.js';
import { nonSingleSpaceFilter } from '../../input-filters/internals/non-single-space-filter.js';
import { trailingSpaceFilter } from '../../input-filters/internals/trailing-space-filter.js';
var spacesPresetSchema = new Types({
  options: {
    type: 'Object',
    def: {
      errorMessages: {
        type: 'Object',
        def: {}
      }
    }
  }
});
/**
 * @typedef spacesPresetErrorMessagesType
 */

/**
 * @typedef spacesPresetOptionsType
 * @property {spacesPresetErrorMessagesType} [errorMessages] - Validation error messages.
 */

/**
 * @description Spaces preset.
 * @param {spacesPresetOptionsType} [options] - Preset options.
 * @returns {{type: 'preset', name: string, groupErrorMessages: Array<string>, plugin: Array<*>}} Preset.
 */

function spacesPreset(options) {
  var _spacesPresetSchema$v = spacesPresetSchema.validate({
    options: options
  });

  options = _spacesPresetSchema$v.options;
  return {
    type: 'preset',
    name: 'spacesPreset',
    groupErrorMessages: {},
    plugin: [leadingSpaceBlocker, nonSingleSpaceBlocker, leadingSpaceFilter, nonSingleSpaceFilter, trailingSpaceFilter]
  };
}

export { spacesPreset };